module.exports = __webpack_public_path__ + "media/images/logo-85bb51f755851960da6c216115e141e5.png";